import { IWindowService } from 'angular';
import AuthService from '../../common/services/auth/auth.service';

/* @ngInject */
export default class HeaderMenuDropdownController {
  constructor(
    public config,
    private $window: IWindowService,
    private authService: AuthService
  ) {}

  public $onInit() {
    document.body.addEventListener('click', (ev: any) => {
      if (
        !(
          ev.target.className === 'login-in-name' ||
          ev.target.parentElement.classList.contains('login-in-name')
        )
      ) {
        const headerEl = document.querySelector('.login-in-name');
        if (headerEl && headerEl.classList.contains('menu-visible')) {
          headerEl.classList.remove('menu-visible');
        }
      }
    });
  }

  public onShowAccountMenu() {
    const headerEl = document.querySelector('.login-in-name');
    if (headerEl) {
      headerEl.classList.contains('menu-visible')
        ? headerEl.classList.remove('menu-visible')
        : headerEl.classList.add('menu-visible');
    }
  }

  public onLogout() {
    this.onShowAccountMenu();
    this.authService
      .logout()
      .finally(
        () => {
          sessionStorage.removeItem("masterpass.token");
          this.$window.location.href = this.config.auth.logout.redirectUrl;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header-menu-dropdown/header-menu-dropdown.controller.ts